import React from 'react';
import AppProvider from './hooks';
import Routes from './routes';
import { GlobalStyle } from './styles/global';
import pt_BR from 'antd/locale/pt_BR';
import en_US from 'antd/locale/en_US';
import es_ES from 'antd/locale/es_ES';
import 'react-quill/dist/quill.snow.css';
import { ConfigProvider } from 'antd';
import { I18nProvider, LanguageCode, useI18n } from './shared/i18n';

const antLocales: Record<LanguageCode, typeof pt_BR> = {
  'pt-BR': pt_BR,
  'en-US': en_US,
  'es-ES': es_ES,
};

const AppShell: React.FC = () => {
  const { language } = useI18n();

  return (
    <>
      <ConfigProvider
        locale={antLocales[language]}
        theme={{
          token: {
            colorPrimary: '#1f725f',
            colorInfo: '#2f5d89',
            colorSuccess: '#15803d',
            colorWarning: '#b7791f',
            colorError: '#c2410c',
            borderRadius: 14,
            colorTextBase: '#143d30',
            colorBgBase: '#f4faf7',
            colorBorderSecondary: 'rgba(24, 90, 66, 0.12)',
            fontFamily: 'Segoe UI, sans-serif',
          },
          components: {
            Button: {
              borderRadius: 14,
              controlHeight: 44,
            },
            Card: {
              borderRadiusLG: 22,
            },
            Input: {
              controlHeight: 46,
            },
            Select: {
              controlHeight: 46,
            },
            Layout: {
              bodyBg: '#f4faf7',
              headerBg: '#ffffff',
              siderBg: '#0f172a',
            },
          },
        }}
      >
        <AppProvider>
          <Routes />
        </AppProvider>
      </ConfigProvider>
      <GlobalStyle />
    </>
  );
};

const App: React.FC = () => {
  return (
    <I18nProvider>
      <AppShell />
    </I18nProvider>
  );
};

export default App;
